import styled from "styled-components";
import Image from "next/image";
import ReactFullpage from "@fullpage/react-fullpage";
import { PrivateJetTravelHeroSection } from "./PrivateJetTravelHeroSection";
import { PrivateJetTravelBenefit, PrivateJetTravelBenefitTablet } from "./PrivateJetTravelBenefit";
import { Grid } from "antd";
import { PrivateJetTravelServices } from "./PrivateJetTravelServices";
import { PrivateJetTravelCardProgram } from "./PrivateJetTravelCardProgram";
import { PrivateJetTravelExplanation } from "./PrivateJetTravelExplanation";
import { MainFooter } from "../../Footer/MainFooter";
import { useState, useEffect } from "react";
import { RAButtonBackToTop } from "@/components/customs";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
const { useBreakpoint } = Grid;
const FULL_PAGE_API_KEY = process.env.NEXT_PUBLIC_FULL_PAGE_API_KEY;

export function PrivateJetTravelSnap({ pageContent = {} }) {
	const { content = {} } = pageContent || {};
	const [activeSlide, setActiveSlide] = useState(0);
	const screens = useBreakpoint();
	const { headerSolid } = useHeaderSolid();

	useEffect(() => {
		return () => {
			fullpage_api.silentMoveTo(1);
		};
	}, []);

	const onLeave = (origin, destination, direction) => {
		setActiveSlide(destination.index);
		headerSolid(destination.index);
		// arguments are mapped in order of fullpage.js callback arguments do something
		// with the event
		if (direction === "up" && destination.index === 1) {
			setTimeout(function () {
				fullpage_api.moveTo(1);
				fullpage_api.moveSectionDown();
			});
		}
	};

	return (
		<HomepageContainer>
			<ReactFullpage
				licenseKey={FULL_PAGE_API_KEY}
				bigSectionsDestination={"top"}
				onLeave={onLeave}
				scrollingSpeed={1100}
				fadingEffect={true}
				normalScrollElements=".ant-picker-panel-container, .ant-modal, #snap-disabled, .ant-picker-time-panel-column, .mapboxgl-canvas, .ant-modal-wrap, .ra-search-airport-ant-select-dropdown"
				credits={{ enabled: false }}
				lazyLoading={false}
				render={({ state, fullpageApi }) => {
					return (
						<ReactFullpage.Wrapper>
							<div className="section" id="pjt-hero-section">
								<PrivateJetTravelHeroSection banner={content?.banner} />
							</div>
							<EachSlide className="section fp-auto-height" id="pjt-travel-explanation">
								<BodyMainContainer>
									<PrivateJetTravelExplanation
										what_is_private_jet_travel={content?.what_is_private_jet_travel}
									/>
								</BodyMainContainer>
							</EachSlide>
							<EachSlide className="section" id="pjt-travel-benefit">
								<BodyLargeContainer>
									{screens?.xl ? (
										<PrivateJetTravelBenefit
											we_operate_differently={content?.we_operate_differently}
										/>
									) : (
										<PrivateJetTravelBenefitTablet
											we_operate_differently={content?.we_operate_differently}
										/>
									)}
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide className="section fp-auto-height" id="pjt-travel-services">
								{/* <BodyContainer
                                    style={{ padding: 0, maxWidth: "100%" }}
                                > */}
								<PrivateJetTravelServices
									the_royal_air_difference={content?.the_royal_air_difference}
								/>
								{/* </BodyContainer> */}
							</EachSlide>
							<EachSlide
								// className={`section ${!screens?.xl ? "fp-auto-height" : ""}`}
								className="section"
								id="pjt-card-program"
								style={{
									position: "relative",
									background: "linear-gradient(180deg, #FFF 0%, #DBE0E5 100%)",
								}}
							>
								<CardProgramBgLeft>
									<Image
										src={PATH_PUBLIC_IMAGES.private_jet_travel_bg_left}
										alt=""
										fill
										style={{ objectFit: "cover", objectPosition: "right center" }}
									/>
								</CardProgramBgLeft>
								<CardProgramBgRight>
									<Image
										src={PATH_PUBLIC_IMAGES.private_jet_travel_bg_right}
										alt=""
										fill
										style={{ objectFit: "cover", objectPosition: "left center" }}
									/>
								</CardProgramBgRight>
								<BodyLargeContainer>
									<PrivateJetTravelCardProgram jet_card_program={content?.jet_card_program} />
								</BodyLargeContainer>
							</EachSlide>
							<EachSlide className="section fp-auto-height" id="footer-section">
								<footer
									style={{
										width: "100vw",
										scrollSnapAlign: "end",
									}}
								>
									<MainFooter />
									<RAButtonBackToTop onClick={() => fullpage_api.moveTo(1)} />
								</footer>
							</EachSlide>
						</ReactFullpage.Wrapper>
					);
				}}
			/>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const BodyLargeContainer = styled.div`
	max-width: 1442px;
	width: 100%;
	padding: 84px 136px;
	@media (max-width: 991px) {
		padding: 40px 80px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const BodyMainContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	/* height: 50vh; */
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	@media (max-width: 991px) {
		padding: 40px 80px;
	}
	@media (max-width: 767px) {
		padding: 30px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;

const EachSlide = styled.div`
	width: 100vw;
	transition: all 0.6s linear;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const CardProgramBgLeft = styled.div`
	position: absolute;
	top: 100px;
	left: 0;
	width: 24%;
	height: 425px;
	pointer-events: none;

	@media (max-width: 1199px) {
		top: 80px;
		width: 30%;
	}

	@media (max-width: 991px) {
		width: 24%;
	}
`;

const CardProgramBgRight = styled.div`
	position: absolute;
	top: 100px;
	right: 0;
	width: 24%;
	height: 425px;
	pointer-events: none;

	@media (max-width: 1599px) {
		width: 28%;
	}

	@media (max-width: 1199px) {
		top: 80px;
		width: 36%;
	}

	@media (max-width: 991px) {
		width: 24%;
	}
`;
